import React from "react";
import PremiumQuoteResults from "./QuoteResultsPremium";

const minibusPublicPricingPolicy = (card) => {
  const isManchesterAirportEstimate = card?.pricing_market === "manchester_airport";
  if (isManchesterAirportEstimate) {
    return { visible: false, reason: "manchester_pricing_review" };
  }
  return { visible: false, reason: "personalised_minibus_quote" };
};

const isManchesterPricingReview = (card) =>
  card?.pricing_market === "manchester_airport";

const minibusResultsConfig = {
  brandName: "MinibusGrab",
  className: "premium-results-minibus",
  funnelTrackingEnabled: true,
  chatBrand: "minibusgrab",
  bookingPath: "/minibus-book",
  defaultVehicles: ["nine", "fourteen"],
  forceEnquiryOnly: true,
  // Manchester prices are temporarily hidden while partner rates are being
  // reviewed. Other MinibusGrab markets remain enquiry-only as before.
  showPublicPricing: true,
  publicPricingPolicy: minibusPublicPricingPolicy,
  publicPriceReason: "personalised_minibus_quote",
  estimateDiscountPercent: 0,
  discountNudgeEnabled: false,
  // Preserve existing MinibusGrab rollback switches alongside shared defaults.
  enquiryImprovementsEnabled: process.env.REACT_APP_MINIBUS_ENQUIRY_V2 !== "false",
  whatsappQuoteEnabled: process.env.REACT_APP_MINIBUS_WHATSAPP_CTA !== "false",
  enquiryIntentEnabled: true,
  cardSpecificEnquiryIntent: true,
  contactPreferenceEnabled: false,
  enquiryButtonLabel: ({ card }) => isManchesterPricingReview(card)
    ? "Get my accurate quote"
    : "Check my best available price",
  noPriceButtonLabel: ({ card }) => isManchesterPricingReview(card)
    ? "Get my accurate quote"
    : "Check my best available price",
  callbackButtonLabel: "Send a quick enquiry",
  secondaryEnquiryMode: "quick_enquiry",
  secondaryEnquiryModalLabel: "Send a quick enquiry",
  enquiryModalLabel: ({ card }) => isManchesterPricingReview(card)
    ? "Get your accurate quote"
    : "Check your best available price",
  enquiryReassurance: ({ card }) => isManchesterPricingReview(card)
    ? null
    : "Free enquiry with no booking or payment. Tell us about passengers and luggage so we can confirm availability and our best available fixed rate.",
  compactEnquiryReassurance: ({ card }) => isManchesterPricingReview(card)
    ? "No payment or obligation. We’ll only use your details to respond to this quote."
    : null,
  publicPriceEyebrow: "Estimated online price from",
  priceSubtext: "Confirm passengers and bags",
  priceEmphasis: "We’ll give you our best available rate",
  noPriceEyebrow: "Your fixed price needs a quick check",
  noPriceLabel: "Get an accurate quote",
  noPriceSubtext: "Share passengers and luggage. We’ll check availability and our best available fixed rate.",
  resultsHeadline: "Your minibus options",
  resultsIntro:
    "To give you an accurate fixed price, we quickly confirm passenger numbers, luggage and vehicle availability. No payment or obligation.",
  estimateDisclaimer:
    "No payment or obligation. Your personalised quote considers passenger needs, children or elderly travellers, luggage, extra stops, pickup time, route conditions and current driver availability.",
  priorityTitle: "Your journey is our priority",
  priorityBody:
    "We monitor flights, traffic and airport conditions in real time to help your group arrive on time.",
  trustItems: [
    { icon: "★", title: "4.8 ★★★★★", body: "Google reviews", href: "https://share.google/trIAb3GAvw55L1l8S" },
    { icon: "♢", title: "Gov UK Registered Operator", body: "Licensed & Insured" },
    { icon: "♙", title: "10,000+ Successful Journeys", body: "Across the UK" },
    { icon: "☎", title: "24/7 Support", body: "Always here to help" },
    { icon: "▣", title: "Secure & Trusted", body: "Your booking is safe" },
  ],
  vehicles: {
    nine: {
      title: "8 Seater Minibus",
      subtitle: "Perfect for small groups and families",
      image: "/minibus-hero.png",
      badge: "Most popular",
      passengers: "8 Passengers",
      bags: "8 Large Bags",
      highlight: "Ideal for families, small groups and business travel",
      similar: "Mercedes V-Class or similar",
      proof: "Personalised group quote",
      bullets: ["No payment taken now", "Passenger and luggage needs checked", "Availability confirmed by our team"],
    },
    fourteen: {
      title: "16 Seater Coach",
      subtitle: "Spacious and comfortable for bigger groups",
      image: "/coach-hero.png",
      badge: "Great for larger groups",
      badgeTone: "rose",
      passengers: "16 Passengers",
      bags: "16 Large Bags",
      highlight: "Perfect for large groups, events and corporate travel",
      similar: "Mercedes Sprinter or similar",
      proof: "Personalised group quote",
      bullets: ["No payment taken now", "Children and accessibility needs checked", "Vehicle and driver confirmed by our team"],
    },
  },
};

const QuoteResultsmini = () => <PremiumQuoteResults config={minibusResultsConfig} />;

export default QuoteResultsmini;
